import { NavLink } from "react-router-dom"
import { Fragment } from "react"

export type TBreadcrumb = {
  name: string
  slug?: string
}

type TBreadcrumbsProps = {
  items: TBreadcrumb[]
}

export default function Breadcrumbs({ items }: TBreadcrumbsProps) {
  const isLastIdx = (idx: number) => items.length - 1 === idx

  const renderedBreadcrumbs = items.map(
    ({ name, slug }: TBreadcrumb, idx: number) =>
      isLastIdx(idx) ? (
        <span key={idx} className="text-lg">
          {name}
        </span>
      ) : (
        <Fragment key={idx}>
          {slug ? (
            <NavLink
              to={slug}
              key={slug}
              className="text-base text-system-gray-500 font-medium"
            >
              {name}
            </NavLink>
          ) : (
            <div className="text-base text-white font-medium">{name}</div>
          )}
          <span
            key={`connector-${slug}`}
            className="text-base text-system-gray-500 line-height-2 mx-2.5 font-medium"
          >
            /
          </span>
        </Fragment>
      ),
  )
  return (
    <div className="flex justify-start items-center my-3">
      {renderedBreadcrumbs}
    </div>
  )
}
